import React, { useState, useEffect, } from 'react';
import { useParams } from "react-router-dom";

import Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';

import { getTeamStatistic } from '../../TeamList/TeamsUtil';
import { getTeamWinnerUid } from '../MatchesUtil';

import Loader from 'react-loader-spinner';
import { withFirebase } from '../../firebase';
import moment from 'moment';
import MatchesListFormSummary from './MatchesListFormSummary';
import { getPlayersStatistic } from '../../Players/PlayerUtil';

const MatchesListForm = (props) => {

    const { tournament_uid } = useParams(); // tournament uid
    const userId = props.firebase.auth.currentUser.uid; // user auth uid

    const { teams, players, matches, showModal, onClose } = props;

    const [match, setMatch] = useState(props.match);
    useEffect(() => {
        setMatch(props.match);
    }, [props.match])

    const matchCopy = Object.assign({}, match);

    const [saving, setSaving] = useState(false);
    const [date, setDate] = useState(matchCopy.date);
    const [place, setPlace] = useState(matchCopy.place);
    const [teamAUid, setTeamAUid] = useState(matchCopy.teamA);
    const [teamBUid, setTeamBUid] = useState(matchCopy.teamB);
    const [goalsA, setGoalsA] = useState(matchCopy.result && matchCopy.result.goalsA);
    const [goalsB, setGoalsB] = useState(matchCopy.result && matchCopy.result.goalsB);
    const [penaltiesA, setPenaltiesA] = useState(matchCopy.result && matchCopy.result.penaltiesA);
    const [penaltiesB, setPenaltiesB] = useState(matchCopy.result && matchCopy.result.penaltiesB);

    let auxMap = matchCopy.result && matchCopy.result.eventMap;
    auxMap = auxMap || {};
    const [eventMap, setEventMap] = useState(auxMap);
    const [eventMapAdded, setEventMapAdded] = useState({});
    const [eventMapDeleted, setEventMapDeleted] = useState({});

    const onSubmit = (e) => {
        e.preventDefault();

        try {

            setSaving(true);
            let updateMatch = {};

            if (date && moment(date).toDate().getTime() != match.date) {
                updateMatch.date = moment(date).toDate().getTime();
            }
            if (place !== match.place) {
                updateMatch.place = place;
            }
            if (place !== match.place) {
                updateMatch.place = place;
            }
            if (teamAUid !== match.teamA) {
                updateMatch.teamA = teamAUid;
            }
            if (teamBUid !== match.teamB) {
                updateMatch.teamB = teamBUid;
            }
            let result = Object.assign({}, matchCopy.result || {});
            let resultChanged = false;
            if (goalsA != result.goalsA) {
                result.goalsA = goalsA;
                resultChanged = true;
            }
            if (goalsB != result.goalsB) {
                result.goalsB = goalsB;
                resultChanged = true;
            }
            if (match.nextMatchUid) {
                if (penaltiesA != result.penaltiesA) {
                    result.penaltiesA = penaltiesA;
                    resultChanged = true;
                }
                if (penaltiesB != result.penaltiesB) {
                    result.penaltiesB = penaltiesB;
                    resultChanged = true;
                }
            }
            if (eventMap != result.eventMap) {
                result.eventMap = eventMap;
                resultChanged = true;
            }

            if (resultChanged) {
                updateMatch.result = result;
            }

            const batch = props.firebase.batch();

            //update teams statistic
            if (resultChanged && !match.nextMatchUid) {
                const teamA = teams.find(item => item.uid === teamAUid);
                const teamB = teams.find(item => item.uid === teamBUid);

                const statistic = getTeamStatistic(teamA, teamB, match.result, result);

                const teamAStatistic = statistic.teamAStatistic;
                const teamBStatistic = statistic.teamBStatistic;

                batch.update(props.firebase.teamDoc(userId, tournament_uid, teamAUid), teamAStatistic);
                batch.update(props.firebase.teamDoc(userId, tournament_uid, teamBUid), teamBStatistic);
            }

            // update next match if has nextMatch
            if (resultChanged && match.nextMatchUid) {
                const nextMatch = matches.find(item => item.uid === match.nextMatchUid);
                if (nextMatch) {
                    const winnerUid = getTeamWinnerUid(match, result);
                    let nextMatchUpdate = { teamA: winnerUid }
                    if (match.index % 2 !== 0) {
                        nextMatchUpdate = { teamB: winnerUid }
                    }
                    // update next match
                    batch.update(props.firebase.matchDoc(userId, tournament_uid, match.nextMatchUid), nextMatchUpdate);
                }
            }

            //update players statistics
            if (Object.keys(eventMapAdded).length > 0 || Object.keys(eventMapDeleted).length > 0) {
                const statistics = getPlayersStatistic(eventMapAdded, eventMapDeleted, players);

                Object.keys(statistics).map(key => {
                    const playerStatistic = statistics[key];
                    batch.update(props.firebase.playerDoc(userId, tournament_uid, key), { statistic: playerStatistic })
                })
            }

            // update match
            batch.update(props.firebase.matchDoc(userId, tournament_uid, match.uid), updateMatch);

            batch.commit().then(() => {
                setSaving(false);
                onClose();
            }).catch(error => {
                setSaving(false);
                console.log("Error: ", error);
                showModal("Error", "Ocurrió un error al editar el partido. Compruebe los datos e intentelo de nuevo.")
                onClose();
            });
        } catch (error) {
            setSaving(false);
            console.log("Error: ", error);
            onClose();
            showModal("Error", "Ocurrió un error al editar el partido. Compruebe los datos e intentelo de nuevo.")
        }
    }

    const updateEventMap = (_eventMap, currentEvent, isNew) => {
        setEventMap(_eventMap)
        if (isNew) {
            eventMapAdded[currentEvent.uid] = currentEvent;
        } else {
            eventMapDeleted[currentEvent.uid] = currentEvent;
        }
    }

    // disable change teams if match has some result
    const disableTeamSelect = (match.result && match.result.goalsA != null && match.result.goalsB != null) ? true : false;
    const disableGoals = !(teamAUid && teamBUid);
    const disabledClass = disableGoals ? "disabled" : "";

    console.log(teams);

    return (

        <div className="">
            {/* <span className="font-weight-bolder ml-2">Editar Partido</span> */}

            <div className="col-12 bg-white border border-white text-decoration-none rounded-lg p-0 ">
                <form onSubmit={onSubmit}>
                    <nav className="">
                        <div className="rounded-lg nav nav-tabs nav-fill justify-content-center flex-row font-weight-bold" id="nav-tab" role="tablist">

                            <a className=" pt-1 pb-1 nav-item nav-link tab-material text-center text-dark active" id="nav-match-result-tab" data-toggle="tab" href="#nav-match-result" role="tab" aria-controls="nav-match-result" aria-selected="true">
                                <span>Resultado</span>
                            </a>

                            <a className={" pt-1 pb-1 nav-item nav-link tab-material text-center text-dark " + disabledClass} id="nav-match-est-tab" data-toggle="tab" href="#nav-match-est" role="tab" aria-controls="nav-match-est" aria-selected="false">
                                <span>Estadisticas</span>
                            </a>

                        </div>
                    </nav>

                    <div className="tab-content pt-0" id="nav-tabContent">

                        <div className="tab-pane fade show active" id="nav-match-result" role="tabpanel" aria-labelledby="nav-match-result-tab">

                            <div className="row m-0">
                                <div className="col row justify-content-center pl-0 pr-0 m-0">

                                    <span className="col-12 small font-weight-bolder pt-1 pl-1">Datos Generales: </span>

                                    <div className="col p-1 pt-0">
                                        <label className="small text-secondary mb-0 ml-1" htmlFor="datepicker">Fecha:</label>
                                        <Datetime
                                            onChange={(d) => setDate(d)}
                                            value={date}
                                            className="rdtPickerDate"
                                            inputProps={{ className: "form-control form-control-sm bg-white text-dark", readOnly: true }}
                                            dateFormat="ddd D [de] MMM YYYY"
                                            timeFormat={false}
                                            closeOnSelect={true}
                                        />
                                    </div>

                                    <div className="col-auto p-1 pt-0">
                                        <label className="small text-secondary mb-0 ml-1" htmlFor="datepicker">Hora:</label>
                                        <Datetime
                                            onChange={(d) => setDate(d)}
                                            value={date}
                                            className="rdtPickerTime"
                                            inputProps={{ className: "form-control form-control-sm bg-white text-dark", readOnly: true }}
                                            timeFormat="HH:mm"
                                            dateFormat={false}
                                            timeConstraints={{ minutes: { step: 5 } }}
                                        />
                                    </div>

                                    <div className="col-12 p-1">
                                        <label className="small text-secondary mb-0 ml-1" htmlFor="place">Lugar o Cancha:</label>
                                        <input className="form-control form-control-sm text-dark" value={place || ''} type="text" onChange={(e) => setPlace(e.target.value)} id="place" placeholder="..." />
                                    </div>

                                    <span className="col-12 small font-weight-bolder mt-2 p-1">Resultado del partido: </span>

                                    {/* Teams select --------------------*/}
                                    <div className="col p-1">
                                        {/* <label className="small text-secondary mb-0 ml-1" htmlFor="teamA">Equipo 1</label> */}
                                        <select disabled={disableTeamSelect} value={teamAUid || ''} onChange={(e) => setTeamAUid(e.target.value)} className="form-control form-control-sm text-dark" id="teamA">
                                            <option className="text-black-50 font-italic" value="">Sin Equipo...</option>
                                            {teams.map((team) => {
                                                console.log(team)
                                                if (team && team.uid)
                                                    return <option key={team.uid} value={team.uid}>{team.title}</option>
                                            })}
                                        </select>
                                    </div>
                                    <div className="col-auto p-1 align-self-end">
                                        <span className="small text-black-50 font-italic">vs</span>
                                    </div>
                                    <div className="col p-1">
                                        {/* <label className="small text-secondary mb-0 ml-1" htmlFor="teamB">Equipo 2</label> */}
                                        <select disabled={disableTeamSelect} value={teamBUid || ''} onChange={(e) => setTeamBUid(e.target.value)} className="form-control form-control-sm text-dark" id="teamB">
                                            <option className="text-black-50 font-italic" value="">Sin Equipo...</option>
                                            {teams.map((team) => {
                                                if (team && team.uid)
                                                    return <option key={team.uid} value={team.uid}>{team.title}</option>
                                            })}
                                            {/* {teams.map(team => <option key={team.uid} value={team.uid}>{team.title}</option>)} */}
                                        </select>
                                    </div>

                                    <div className="w-100"></div>

                                    {/* Match result --------------------*/}
                                    <div className="col-auto p-1">
                                        <input disabled={disableGoals} className="form-control form-control-sm text-center" id="goalsA" style={{ width: 60 }}
                                            value={goalsA == null ? '' : goalsA} type="number" min="0"
                                            onChange={(e) => setGoalsA(e.target.value != '' ? parseInt(e.target.value, 10) : null)} />
                                    </div>
                                    <div className="col-auto p-1 align-self-endr">
                                        <span> - </span>
                                    </div>
                                    <div className="col-auto p-1">
                                        <input disabled={disableGoals} className="form-control form-control-sm text-center" id="goalsB" style={{ width: 60 }}
                                            value={goalsB == null ? '' : goalsB} type="number" min="0"
                                            onChange={(e) => setGoalsB(e.target.value != '' ? parseInt(e.target.value, 10) : null)} />
                                    </div>

                                    <div className="w-100"></div>

                                    {/* Penalties --------------------*/}
                                    {/* {match.nextMatchUid ? */}
                                    <>
                                        <span className="col-12 small text-center pt-1">Penales: </span>
                                        <div className="col-auto p-1">
                                            <input disabled={disableGoals || !match.nextMatchUid} className="form-control form-control-sm text-center" id="penaltiesA" style={{ width: 60 }}
                                                value={penaltiesA == null ? '' : penaltiesA} type="number" min="0"
                                                onChange={(e) => setPenaltiesA(e.target.value != '' ? parseInt(e.target.value, 10) : null)} />
                                        </div>
                                        <div className="col-auto p-1 align-self-endr">
                                            <span> - </span>
                                        </div>
                                        <div className="col-auto p-1">
                                            <input disabled={disableGoals || !match.nextMatchUid} className="form-control form-control-sm text-center" id="penaltiesB" style={{ width: 60 }}
                                                value={penaltiesB == null ? '' : penaltiesB} type="number" min="0"
                                                onChange={(e) => setPenaltiesB(e.target.value != '' ? parseInt(e.target.value, 10) : null)} />
                                        </div>
                                    </>
                                    {/* :
                                        <></>
                                    } */}
                                </div>
                            </div>
                        </div>

                        <div className="tab-pane fade " id="nav-match-est" role="tabpanel" aria-labelledby="nav-match-est-tab">
                            <div >
                                <MatchesListFormSummary
                                    updateEventMap={updateEventMap}
                                    eventMap={eventMap || {}}
                                    teams={teams}
                                    teamAUid={teamAUid}
                                    teamBUid={teamBUid}
                                    players={players} />
                            </div>
                        </div>

                    </div>

                    {(!saving) ?
                        <div className="col-12 d-flex flex-row-reverse p-0 mt-2">
                            <button type="submit" className="col-auto btn btn-sm btn-success m-1">Guardar</button>
                            <button onClick={onClose} className="col-auto btn btn-sm btn-secondary m-1">Cancelar</button>
                        </div>
                        :
                        <div className="col-12 d-flex flex-row-reverse p-0 mt-2">
                            <Loader className=""
                                type="ThreeDots"
                                color="#263238"
                                height={39}
                                width={50}
                                timeout={0} />
                        </div>
                    }
                </form>
            </div>


        </div>
    )

}

export default withFirebase(MatchesListForm);
